import React from "react";
import { Link } from "react-router-dom";
import { SidebarContent } from "./sidebar-content";

export const SideBar = (props) => {
  return (
    <React.Fragment>
      <div className="vertical-menu text-start" >
        <div className="navbar-brand-box text-start ">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src="/vv-media-logo-twin.png" alt="" height="18" />
            </span>
            <span className="logo-lg text-center ms-5">
              <img src="/vv-media-logo-twin.png" alt="" height="25" />
              Media
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src="/vv-media-logo-twin.png" alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src="/vv-media-logo-twin.png" alt="" height="19" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};
